<template>
	<v-container fluid>
		<click-day-component></click-day-component>
	</v-container>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>